import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
import ClearableInput from '../clearableInput/ClearableInput';
const TableSearch = (props) => {
    const { className } = props, remainingProps = __rest(props, ["className"]);
    return (_jsxs("div", Object.assign({ className: classNames('table-toolbar-search', 'input-group', className) }, { children: [_jsx("span", Object.assign({ className: 'input-group-addon' }, { children: _jsx("span", { className: 'rioglyph rioglyph-search' }) })), _jsx(ClearableInput, Object.assign({}, remainingProps))] })));
};
export default TableSearch;
